module.exports = __webpack_public_path__ + "static/media/3 04 Tulleord Modil er feil.d7d60feb.mp3";